import { createFileRoute } from '@tanstack/react-router'

import { LegalAssistancePageSkeleton } from '#/modules/legal-assistance/front-office/legal-assistance-page/legal-assistance-page-skeleton.tsx'
import { LegalAssistancePage } from '#/modules/legal-assistance/front-office/legal-assistance-page/legal-assistance-page.tsx'
import { FRONT_OFFICE_V2_QUERY_OPTIONS } from '#/shared/front-office-v2-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/legal-assistance-v2/')({
  beforeLoad: ({ context }) => requirePermissions(context, ['contract.read']),
  loader: ({ context }) => {
    const { queryClient, trpc } = context
    return queryClient.ensureQueryData(
      trpc.legalAssistance.getClientLegalAssistanceAccess.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
    )
  },
  pendingComponent: LegalAssistancePageSkeleton,
  pendingMs: 150,
  component: LegalAssistancePage,
})
